import classNames from 'classnames'
import React from 'react'
import Text from '../Text'

const RadioButton = ({
  label,
  description,
  isSelected,
  onClick,
  className,
}) => {
  return (
    <button
      className={classNames(
        'flex items-center gap-2 border py-2.5 px-3.5 rounded-[8px]',
        className,
        isSelected ? 'border-[#444CE7] bg-[#EEF4FF]' : 'border-[#E4E7EC]',
      )}
      onClick={onClick}
    >
      <div
        className={classNames(
          'w-6 h-6 max-w-6 max-h-6 rounded-full border-[1px] p-[3px]',
          isSelected
            ? 'border-[#444CE7] ring-[#EBF2FF] ring-4'
            : 'border-[#444CE7]',
        )}
      >
        <div
          className={classNames(
            'w-4 h-4 rounded-full bg-[#444CE7] transition-opacity duration-500',
            isSelected ? 'opacity-100' : 'opacity-0',
          )}
        />
      </div>
      <div className="flex flex-col">
        <label
          className={classNames(
            'text-base font-medium text-left',
            isSelected ? 'text-[#2D3282]' : 'text-[#667085]',
          )}
        >
          {label}
        </label>
        {description && (
          <Text
            variant="label"
            size="medium"
            className={classNames(
              isSelected ? 'text-[#2D3282]' : 'text-[#667085]',
            )}
            tag="p"
          >
            {description}
          </Text>
        )}
      </div>
    </button>
  )
}

export default RadioButton
